import { newClock, type Clock } from "./clock";

/**
 * Одни часы на все заходы в задачу.
 *
 * Экран Solve размонтируется при переходе в разбор или atlas, но решение от
 * этого не начинается заново. Реестр живёт в App и удаляет часы только после
 * подтверждённого сервером ответа.
 */
export class TaskClocks {
  private readonly clocks = new Map<string, Clock>();

  constructor(private readonly create: () => Clock = newClock) {}

  get(itemKey: string): Clock {
    const existing = this.clocks.get(itemKey);
    if (existing !== undefined) return existing;
    const clock = this.create();
    this.clocks.set(itemKey, clock);
    return clock;
  }

  complete(itemKey: string): void {
    this.clocks.delete(itemKey);
  }
}
